/* eslint-disable react/no-deprecated, @typescript-eslint/no-var-requires,@typescript-eslint/no-explicit-any */

// React 16 moved these out of core - some dependencies require them
// NB. using require instead of import to avoid misisng types failing builds - we don't use them directly
const createClass = require("create-react-class");
const PropTypes = require("prop-types");
const DOM = require("react-dom-factories");
import React from "react";

const react = React as any;
react.createClass = createClass; // Required by react-datetime
react.PropTypes = PropTypes; // Required by armstrong form and others
react.DOM = DOM; // Required by react-datetime
